import { useState } from 'react';
import type { ScopeScreenshot } from '../hooks/useScopeStream.js';

export function ScreenshotStrip({ screenshots }: { screenshots: ScopeScreenshot[] }) {
  const [enlarged, setEnlarged] = useState<string | null>(null);

  if (screenshots.length === 0) {
    return (
      <div className="flex h-full items-center justify-center rounded-xl text-xs text-text-dimmed" style={{ border: '1px dashed var(--border)' }}>
        Screenshots will appear here
      </div>
    );
  }

  return (
    <>
      <div className="flex gap-2 overflow-x-auto pb-1">
        {screenshots.map((s, i) => (
          <button
            key={i}
            type="button"
            onClick={() => setEnlarged(s.url)}
            className="shrink-0 rounded-lg overflow-hidden transition-opacity hover:opacity-80"
            style={{ border: '1px solid var(--glass-border)', width: 120, height: 80 }}
            title={s.caption ?? s.step}
          >
            <img
              src={s.url}
              alt={s.caption ?? s.step}
              className="w-full h-full object-cover"
              loading="lazy"
            />
          </button>
        ))}
      </div>

      {enlarged && (
        <div
          className="fixed inset-0 z-50 flex items-center justify-center"
          style={{ background: 'rgba(0,0,0,0.8)' }}
          onClick={() => setEnlarged(null)}
        >
          <img
            src={enlarged}
            alt="Screenshot"
            className="max-w-[90vw] max-h-[90vh] rounded-xl"
            style={{ boxShadow: '0 8px 40px rgba(0,0,0,0.7)' }}
            onClick={(e) => e.stopPropagation()}
          />
          <button
            type="button"
            onClick={() => setEnlarged(null)}
            className="absolute top-4 right-4 text-white text-xl font-bold opacity-70 hover:opacity-100"
          >
            ✕
          </button>
        </div>
      )}
    </>
  );
}
